import React, { useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import { INTERVALO } from '../../../../config/settings'
import * as actions from './../../actions'
import PesadoBrutoBalancero from './PesadoBrutoBalancero'

function PesadoBruto (props) {
  const { receiveParametros, actualizacion } = props

  const actualizarDatos = useCallback(() => {
    props.estadoOcupacionCallesDeCalados()
    props.queryParametrosBruto()
    props.obtenerCallesVolcadora()
    props.callesDeCaladoPorCerealHumedad()
    props.calificacionCalleDeCalado()
    props.getCamionesCalados()
    props.camionesEntrePlayaCalado()
    props.camionesListosParaBruto()
    props.obtenerEstadoPedidosCereal()
    props.obtenerCamionesEntreBrutoYDestare()
    props.obtenerCerealAsignadoAVolcadora()
  }, [props])

  useEffect(() => {
    function setUp () {
      actualizarDatos()
    }

    const interval = setInterval(async () => {
      if (actualizacion) {
        setUp()
      }
    }, [INTERVALO])

    if (!receiveParametros) {
      actualizarDatos()
    }

    if (actualizacion) {
      setUp()
    }

    return () => {
      clearInterval(interval)
    }
  }, [actualizarDatos, receiveParametros, actualizacion])

  return (
    <div className='pesado-container' style={{ margin: '-2% auto 0 auto' }}>
      <PesadoBrutoBalancero actualizarDatos={actualizarDatos} />
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    actualizacion: state.pesado.actualizacionHabilitada,
    receiveParametros: state.pesado.receiveParametrosBruto
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(PesadoBruto)
